/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AutomationInputs */

const cs_nav_automation = /** @type {(inputs: Nav_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatizace`)
};

const en_nav_automation = /** @type {(inputs: Nav_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Nav_AutomationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_automation = /** @type {((inputs?: Nav_AutomationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AutomationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_automation(inputs)
	return cs_nav_automation(inputs)
});